import { jsxs, jsx } from 'react/jsx-runtime';

function Submenu({ children, icon, title }) {
    return (jsxs("div", { className: "sidebar__submenu", children: [jsxs("div", { className: "sidebar__item", children: [jsx("div", { className: "sidebar__item__icon", children: icon }), jsx("div", { className: "sidebar__item__text", children: title })] }), jsx("div", { className: "sidebar__submenu__menu", children: children })] }));
}
Submenu.defaultProps = {
    children: null,
    icon: null,
    title: '',
};

export { Submenu as default };
